module.exports = __webpack_public_path__ + "images/fc4e2ca0bb058a4221c0c531c6c8d3b9-BACALAR-WHITE.png";